import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  driversInSegment: {},
})

const { Types, Creators } = createActions({
  setDriverIncentives: ['data'],
  resetDrivers: null,
  setDriverLoading: ['val'],
  syncDriversBySegment: ['driverSegment', 'startFrom', 'endAt']
})

export const setDriverLoadingReducer = (state, { val }) =>
  state.set('loading', val)

export const setDriverIncentivesReducer = (state, { data }) =>
  state.set('driversInSegment', data).set('loading', false)

export const resetDriversReducer = (state) => state.set('driversInSegment', {})

export const driverIncentiveReducer = createReducer(INITIAL_STATE, {
  [Types.SET_DRIVER_INCENTIVES]: setDriverIncentivesReducer,
  [Types.RESET_DRIVERS]: resetDriversReducer,
  [Types.SET_DRIVER_LOADING]: setDriverLoadingReducer,
})

export const DriverIncentiveTypes = Types
export default Creators


// WEBPACK FOOTER //
// ./src/reducers/driverIncentiveReducer.js